import React from "react";

const PastorSermon = () => {
  return (
    <section className="p-8 md:p-12 text-center bg-purple-800">
      <h2 className="text-3xl font-bold mb-4">Sermon Message</h2>

      <p className="mb-6 italic max-w-2xl mx-auto">
        “Faith comes by hearing the word of God.”
        <br />
        <span className="block mt-2 text-yellow-300 font-semibold">
          — Romans 10:17
        </span>
      </p>

      <div className="flex justify-center">
        <div className="w-full max-w-4xl aspect-video rounded-xl overflow-hidden shadow-lg">
          <iframe
            className="w-full h-full"
            src="https://www.youtube.com/embed/OUId_-o1fzU?start=164"
            title="3 Battles Every Christian Must Win"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default PastorSermon;